import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Swal from 'sweetalert2';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { financeLisitingRequest, deleteFinance } from './redux/financeDispatcher';
import {cur} from '../../constant/Constants';
import { webSiteUrl } from '../../constant/ApiUrls';

function FinanceTable() {
    const dispatch = useDispatch();
    const location = useLocation();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const { financeListing, totalFinance, loading } = useSelector(
        state => state.financeReducer
    );

    const handleView = (row) => {
        setSelectedRow(row);
        setOpenDialog(true);
    };

    const handleDelete = (row) => {
        Swal.fire({
            title: '',
            html: `Are you sure?<br>You want to delete this finance entry?`,
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteFinance(row.id)); // assumes 'id' is unique
            }
        });
    };

    const columns = [
        {
            field: "id",
            headerName: "No",
            width: 70,
            renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + page * pageSize,
        },
        { field: "firstName", headerName: "First Name", width: 150 },
        { field: "surname", headerName: "Last Name", width: 150 },
        { field: "email", headerName: "Email", width: 300 },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <div style={{
                    display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
                    height: "100%"
                }}>
                    <button
                        onClick={() => handleView(params.row)}
                        style={{
                            backgroundColor: "#1b87f4",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            borderRadius: "4px",
                            fontSize: "10px",
                            width: "100%",
                            height: "24px",
                            padding: "2px 5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        View
                    </button>


                    <button
                        onClick={() => {
                            const adId = params.row.ad_id; // Make sure ad_id exists
                            window.open(`${webSiteUrl}ads/${adId}`, "_blank");
                        }}
                        style={{
                            backgroundColor: "#1b87f4",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            borderRadius: "4px",
                            fontSize: "10px",
                            width: "100%",
                            height: "24px",
                            padding: "2px 5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        View Ad
                    </button>


                    <button
                        onClick={() => handleDelete(params.row)}
                        style={{
                            backgroundColor: "#F44336",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            borderRadius: "4px",
                            fontSize: "10px",
                            width: "100%",
                            height: "24px",
                            padding: "2px 5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    useEffect(() => {
        dispatch(financeLisitingRequest(page + 1, pageSize));
    }, [dispatch, page, pageSize, location.pathname]);

    return (
        <>
            <Paper sx={{ height: "95%", width: '100%' }}>
                <DataGrid
                    rows={financeListing || []}
                    columns={columns}
                    rowCount={totalFinance || 0}
                    paginationModel={{ page, pageSize }}
                    paginationMode="server"
                    onPaginationModelChange={({ page, pageSize }) => {
                        setPage(page);
                        setPageSize(pageSize);
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    loading={loading}
                    rowHeight={36}
                    disableRowSelectionOnClick
                    sx={{ border: 0 }}
                    getRowId={(row) => `${row.id}`}
                />
            </Paper>

            {/* View Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Finance Details</DialogTitle>
                <DialogContent dividers>
                    {selectedRow && (
                        <div style={{ lineHeight: "1.8", fontSize: "14px" }}>
                            <h3>Personal Info</h3>
                            <div><strong>Title:</strong> {selectedRow.title}</div>
                            <div><strong>First Name:</strong> {selectedRow.firstName}</div>
                            <div><strong>Surname:</strong> {selectedRow.surname}</div>
                            <div><strong>Maiden Name:</strong> {selectedRow.maidenName}</div>
                            <div><strong>Email:</strong> {selectedRow.email}</div>
                            <div><strong>Mobile:</strong> {selectedRow.phoneCode} {selectedRow.mobile}</div>
                            <div><strong>DOB:</strong> {new Date(selectedRow.dob).toLocaleDateString()}</div>
                            <div><strong>Gender:</strong> {selectedRow.gender}</div>
                            <div><strong>Marital Status:</strong> {selectedRow.maritalStatus}</div>
                            <div><strong>Number of Dependents:</strong> {selectedRow.numberOfDependents}</div>
                            <div><strong>Country of Birth:</strong> {selectedRow.countryOfBirth}</div>
                            <div><strong>PPS Number:</strong> {selectedRow.ppsNumber}</div>
                            <div><strong>Vehicle Reg. Number:</strong> {selectedRow.vehicleRegistrationNumber}</div>

                            <h3 style={{ marginTop: "20px" }}>Residential Info</h3>
                            <div><strong>Status:</strong> {selectedRow.residentialStatus}</div>
                            <div><strong>Address 1:</strong> {selectedRow.residentialCurrentAddress1}</div>
                            <div><strong>Address 2:</strong> {selectedRow.residentialCurrentAddress2}</div>
                            <div><strong>Town:</strong> {selectedRow.residentialTown}</div>
                            <div><strong>Country:</strong> {selectedRow.residentialCountry}</div>
                            <div><strong>Eircode:</strong> {selectedRow.residentialEircode}</div>
                            <div><strong>Time at Address:</strong> {selectedRow.residentialTimeAtCurrentAddress}</div>

                            <h3 style={{ marginTop: "20px" }}>Employment Info</h3>
                            <div><strong>Industry:</strong> {selectedRow.industryCategory}</div>
                            <div><strong>Occupation:</strong> {selectedRow.occupation}</div>
                            <div><strong>Employment Type:</strong> {selectedRow.employmentType}</div>
                            <div><strong>Employment Status:</strong> {selectedRow.employmentStatus}</div>
                            <div><strong>Employer:</strong> {selectedRow.employerName}</div>
                            <div><strong>Employer Phone:</strong> {selectedRow.employerPhoneCode} {selectedRow.employerPhone}</div>
                            <div><strong>Employer Address 1:</strong> {selectedRow.employerAddress1}</div>
                            <div><strong>Employer Address 2:</strong> {selectedRow.employerAddress2}</div>
                            <div><strong>Town:</strong> {selectedRow.employerTown}</div>
                            <div><strong>Country:</strong> {selectedRow.employerCountry}</div>
                            <div><strong>Time at Employer:</strong> {selectedRow.timeAtEmployer}</div>

                            <h3 style={{ marginTop: "20px" }}>Finance Info</h3>
                            {/* <div><strong>Ad ID:</strong> {selectedRow.ad_id}</div> */}
                            {/* <div><strong>Status:</strong> {selectedRow.status}</div> */}
                            <div><strong>Price:</strong> {cur}{selectedRow.price}</div>
                            <div><strong>Deposit:</strong> {cur}{selectedRow.deposit}</div>
                            <div><strong>Trade-in Value:</strong> {cur}{selectedRow.tradeInValue}</div>
                            <div><strong>Outstanding Finance:</strong> {cur}{selectedRow.outstandingFinance}</div>
                            <div><strong>Finance Amount:</strong> {cur}{selectedRow.financeAmount}</div>
                            <div><strong>Term (years):</strong> {selectedRow.term}</div>
                            <div><strong>Monthly Repayment:</strong> {cur}{selectedRow.monthlyRepayment}</div>
                            <div><strong>Interest %:</strong> {selectedRow.intrustPercent}</div>
                            <div><strong>Total Payable:</strong> {cur}{selectedRow.totalAmountPayable}</div>

                            <h3 style={{ marginTop: "20px" }}>Bank Info</h3>
                            <div><strong>Primary Bank:</strong> {selectedRow.primaryBank}</div>
                            <div><strong>Account Type:</strong> {selectedRow.accountType}</div>
                            <div><strong>Account Holder Name:</strong> {selectedRow.accountHolderName}</div>
                            <div><strong>Years with Bank:</strong> {selectedRow.yearsWithBank}</div>
                            <div><strong>Monthly Income After Tax:</strong> {cur}{selectedRow.monthlyIncomeAfterTax}</div>
                            <div><strong>Monthly Mortgage or Rent:</strong> {cur}{selectedRow.monthlyMortgageOrRent}</div>

                            {/* <h3 style={{ marginTop: "20px" }}>Other</h3> */}
                            {/* <div><strong>Consent Given:</strong> {selectedRow.consentGiven ? "Yes" : "No"}</div> */}
                            {/* <div><strong>Created At:</strong> {new Date(selectedRow.created_at).toLocaleString()}</div> */}
                            {/* <div><strong>Updated At:</strong> {new Date(selectedRow.updated_at).toLocaleString()}</div> */}
                        </div>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary" variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default FinanceTable;
